import { useMutation, useQueryClient } from '@tanstack/react-query';

import { requestUploadUrl, uploadToS3, submitClaim } from '@/services/claims';

import type { IClaimSubmission } from '@/types/claim';

interface ClaimSubmissionParams {
  claimData: IClaimSubmission;
  receiptFile: File;
}

export function useClaimSubmission() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ claimData, receiptFile }: ClaimSubmissionParams) => {
      let uploadedS3Key: string | null = null;
      try {
        const { uploadUrl, s3Key } = await requestUploadUrl(receiptFile.name, receiptFile.type);
        await uploadToS3(uploadUrl, receiptFile);
        uploadedS3Key = s3Key;

        const finalClaimData = { ...claimData, receiptS3Key: s3Key };
        return await submitClaim(finalClaimData);
      } catch (error) {
        if (uploadedS3Key) {
          console.warn('Claim failed after S3 upload:', uploadedS3Key);
        }
        throw error;
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      void queryClient.invalidateQueries({ queryKey: ['claims'] });
    },
  });
}
